import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AlertService, AuthenticationService } from '../_services/index';
import { IMessage } from 'ng2-semantic-ui';

@Component({
	moduleId: module.id,
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnDestroy {
	private subscription: Subscription;
	message: any;

	constructor(
		private alertService: AlertService,
		public auth: AuthenticationService
	) {
		this.subscription = alertService.getMessage().subscribe(message => 	{ 
			this.message = message; 
		});
	}

	ngOnDestroy(): void {
		// unsubscribe on destroy to prevent memory leaks
		this.subscription.unsubscribe();
	}

	public dismiss(message: IMessage) {
		message.dismiss();
		this.alertService.clear();
	}

}
